<!--
 * @Author: 
 * @LastEditTime: 2024-04-26 18:37:43
 * @Description: 
-->
<template>
  <div class="h-full w-full relative">
    <div class="w-full h-30/100 overflow-y-auto">
      <CategoryTitle title="区域统计" class="mt-10px" />
      <div class="h-[calc(100%-28px)]">
        <v-chart
          :options="personOptions"
          :autoresize="true"
          class="h-full w-full"
          :init-options="{ devicePixelRatio: 2 }"
        ></v-chart>
      </div>
    </div>
    <div class="w-full h-30/100 overflow-y-auto">
      <CategoryTitle title="部门统计" class="mt-10px" />
      <div class="mt-5px h-[calc(100%-36px)]">
        <v-chart
          :options="joinUnitOptions"
          :autoresize="true"
          class="h-full w-full"
          :init-options="{ devicePixelRatio: 2 }"
        ></v-chart>
      </div>
    </div>
    <div class="w-full h-35/100 overflow-y-auto">
      <CategoryTitle title="人员清单" class="mt-10px" />
      <div class="mt-5px h-[calc(100%-36px)]">
        <!-- <el-row class="w-full">
          <el-col :span="8">
            <el-select
              v-model="isOnline"
              placeholder="在线情况"
              popper-class="visualization-select-popper"
              clearable
            >
              <el-option
                v-for="item in statusList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="16">
            <el-input
              placeholder="请输入关键词"
              v-model="search.searchKeyword"
              size="small"
              clearable
              class="icon-search__input mb-10px"
            >
              <i slot="append" class="el-icon-search cursor-pointer icon-search__input"></i>
            </el-input>
          </el-col>
        </el-row> -->
        <!-- <el-tree
          :data="treeData"
          :props="defaultProps"
          node-key="label"
          class="bg-transparent text-white"
        >
          <template #default="{ node, data }">
            <div class="tree-item flex justify-between items-center w-80/100">
              <div>
                <i class="iconfont el-icon-search font-size-16 mr-5px"></i>
                <span class="tree-item__label">{{ data.label }}</span>
              </div>
              <div>
                <span class="mr-10px" @click.prevent.stop="openPersonInfo(data)"
                  ><div class="inline-block w-16px h-16px mr-2px tree-position-icon"></div>
                  定位</span
                >
                <span
                  ><div class="inline-block w-16px h-16px mr-2px tree-route-icon"></div>
                  路线</span
                >
              </div>
            </div>
          </template>
        </el-tree> -->
        <div class="mb-10px flex items-center">
          <el-select v-model="searchStatus" popper-class="visualization-select-popper">
            <el-option label="在线" :value="0"></el-option>
            <el-option label="离线" :value="1"></el-option>
          </el-select>
          <el-input
            placeholder="请输入关键字"
            suffix-icon="el-icon-search"
            v-model.trim="personnelKeyword"
          >
          </el-input>
        </div>
        <cockpit-tree
          class="mt-10px overflow-auto pr-12px"
          v-loading="treeLoading"
          :treeLoading="treeLoading"
          :treeData="treeData"
          :customFilter="customFilter"
        >
          <template #btns="{ node }">
            <div class="flex items-center mr-15px cursor-pointer" @click.stop.prevent="openPersonInfo(node)" v-if="searchStatus === 0">
              <div class="h-14px w-15px location-icon mr-5px"></div>
              <span>定位</span>
            </div>
            <div class="flex items-center mr-15px cursor-pointer">
              <div class="h-14px w-15px route-icon mr-5px"></div>
              <span>路线</span>
            </div>
          </template>
        </cockpit-tree>
      </div>
    </div>
  </div>
</template>

<script>
import CardTitle from '@/components/cockpit/CardTitle'
import CategoryTitle from '@/components/cockpit/CategoryTitle'
import CockpitTree from '@/components/cockpit/CockpitTree'
export default {
  name: 'TsgPersonPosition',
  components: {
    CardTitle,
    CategoryTitle,
    CockpitTree,
  },
  data() {
    return {
      treeLoading: false,
      personnelKeyword: '',
      searchStatus: 0,
      personOptions: {
        color: ['#3a53d4', '#6cd29b', '#75fbfd', '#feff53', '#ef8f53', '#6b36d5'],
        tooltip: {
          confine: true,
          trigger: 'item',
          textStyle: {
            fontSize: 12,
          },
          confine: true,
          borderWidth: 1,
          borderColor: '#35d0dd',
          backgroundColor: 'rgba(17,83,71,0.6)',
        },
        grid: {
          top: 0,
        },
        legend: {
          right: 40,
          top: 'center',
          // 垂直
          orient: 'vertical',
          itemGap: 10,
          itemWidth: 6,
          itemHeight: 6,
          textStyle: {
            color: '#fff',
            rich: {
              value: {
                fontSize: 12,
              },
              title: {
                fontSize: 12,
                color: '#fff9',
                width: 80,
              },
              unit: {
                fontSize: 10,
                color: '#fff9',
              },
            },
          },
        },
        tooltip: {
          trigger: 'item',
          feature: {
            mark: { show: true },
            dataView: { show: true },
          },
          textStyle: {
            fontSize: 12,
          },
          confine: true,
          borderWidth: 1,
          borderColor: '#35d0dd',
          backgroundColor: 'rgba(17,83,71,0.6)',
        },
        series: [
          {
            type: 'pie',
            radius: ['70%', '72%'],
            color: ['rgba(217,217,217,0.1)'],
            center: ['30%', '50%'],
            data: [1],
            silent: true,
            label: {
              show: true,
              position: 'center',
              rich: {
                title: {
                  color: 'rgba(255, 255, 255, 0.8)',
                  fontSize: 12,
                },
                value: {
                  color: 'rgb(255, 255, 255)',
                  fontSize: 20,
                  fontWeight: 'bold',
                  padding: [6, 0],
                },
              },
            },
            markPoint: {
              symbol: 'circle',
              symbolSize: 4,
              emphasis: {
                disabled: true,
              },
              animation: false,
              silent: true,
              itemStyle: {
                color: '#FFF',
              },
              data: [
                {
                  x: '11%',
                  y: '50%',
                },
                {
                  x: '49%',
                  y: '50%',
                },
              ],
            },
          },
          {
            type: 'pie',
            radius: ['35%', '40%'],
            center: ['30%', '50%'],
            silent: true,
            label: {
              show: false,
            },
            data: [1],
          },
          {
            type: 'pie',
            radius: ['40%', '62%'],
            center: ['30%', '50%'],
            hoverAnimation: true,
            textStyle: {
              align: 'center',
            },
            label: {
              show: false,
            },
            itemStyle: {
              borderColor: '#07304d',
              borderWidth: 2,
            },
            data: [
              {
                value: 1,
                name: '3号主厂房',
              },
              {
                value: 1,
                name: '4号主厂房',
              },
              {
                value: 1,
                name: '3号锅炉',
              },
              {
                value: 1,
                name: '4号锅炉',
              },
            ],
          },
        ],
      },
      joinUnitOptions: {
        color: ['#5087ec', '#68bbc4'],
        tooltip: {
          trigger: 'axis',
          textStyle: { fontSize: 12 },
          confine: true,
          borderWidth: 1,
          borderColor: '#35d0dd',
          backgroundColor: 'rgba(17,83,71,0.6)',
        },
        title: {
          // text: '万',
          left: '3%', // 设置水平位置
          top: '0%', // 设置垂直位置
          textStyle: {
            color: '#ffffffb3', // 标题颜色
            fontSize: 14, // 字体大小
          },
        },
        legend: {
          textStyle: { color: '#ffffffb3', fontSize: 12 },
          left: 'center',
          top: -2,
          itemWidth: 10,
          itemHeight: 10,
          data: ['办公区', '施工区'],
        },
        grid: { bottom: 20, top: 24, right: 10 },
        xAxis: {
          type: 'category',
          data: ['运行部', '检修部', '安全部', '生产技术部', '经营管理'],
          splitArea: {
            show: false,
            areaStyle: { color: ['rgba(255,255,255,0.05)', 'transparent'] },
          },
          splitLine: { show: false },
          axisLabel: { color: '#fff9', fontSize: 12, show: true, interval: 0 },
          axisTick: { show: false, interval: 0 },
          axisLine: { lineStyle: { color: '#ffffff4d', fontSize: 12 } },
        },
        yAxis: {
          type: 'value',
          // 隐藏网格线
          splitLine: {
            lineStyle: { color: ['rgba(255,255,255,0.05)'], type: 'dashed' },
            show: false,
          },
          // splitNumber: 3,
          nameLocation: 'end',
          nameGap: 10,
          nameTextStyle: { color: '#fff9', padding: [-10, 0, 0, -30], fontSize: 12 },
          minInterval: 1,
          splitArea: { show: false },
          axisTick: { show: false },
          axisLabel: { color: '#fff9', fontSize: 9 },
          axisLine: { show: false, lineStyle: { color: '#ffffff4d' } },
        },
        series: [
          {
            type: 'bar',
            name: '办公区',
            barWidth: 10,
            data: [
              12,
              14,
              17,
              11,
              12,
              // { value: 12, itemStyle: { color: 'rgb(47, 117, 181)' } },
              // { value: 14, itemStyle: { color: 'rgb(84, 130, 53)' } },
            ],
            // showSymbol: false, // 隐藏拐点
            // stack: 'group1',
          },
          {
            type: 'bar',
            name: '施工区',
            barWidth: 10,
            data: [
              16,
              10,
              20,
              15,
              10,
              // { value: 16, itemStyle: { color: 'rgb(155, 194, 230)' } },
              // { value: 10, itemStyle: { color: 'rgb(169, 208, 142)' } },
            ],
            // showSymbol: false,
            // stack: 'group2',
          },
        ],
      },
      isOnline: '在线',
      statusList: [
        { label: '在线', value: '在线' },
        { label: '离线', value: '离线' },
      ],
      search: {
        searchKeyword: '',
      },
      treeData: [
        {
          keyId: 1,
          name: '总部',
          childen: [
            {
              keyId: 2,
              name: '办公区',
              childen: [
                {
                  keyId: 3,
                  name: '运行部',
                  childen: [
                    {
                      keyId: 4,
                      name: '张三',
                    },
                  ],
                }
                ],
            },
          ],
        }
      ],
      defaultProps: {
        children: 'children',
        label: 'label',
      },
    }
  },
  methods: {
    // 打开人员信息
    openPersonInfo(item) {
      this.$emit('transferEvent', {
        toCom: {
          code: 'TsgPersonInfo',
          origin: 'TsgPersonPosition',
          name: '人员信息',
        },
        type: 'mainComponent',
        props: {},
      })
    },
    // 过滤
    customFilter(value, data) {
      return includes(data.name, value.personnelKeyword)
    },
  },
  async created() {},
}
</script>

<style>
.tree-position-icon {
  background: url('../../../assets/images/personPosition/tree_position.png') no-repeat center;
  background-size: 100%;
  vertical-align: middle;
}
.tree-route-icon {
  background: url('../../../assets/images/personPosition/tree_line.png') no-repeat center;
  background-size: 100%;
  vertical-align: middle;
}
.location-icon {
  background: url('../../../assets/images/control/location.png');
  background-size: 100% 100%;
}
.route-icon {
  background: url('../../../assets/images/control/route.png');
  background-size: 100% 100%;
}
</style>
